export default "__VITE_ASSET__DEKeYG7I__"